export default __webpack_public_path__ + "static/media/PREVIEWICONA.9608fafe.svg";